export const Version = 247;
//# sourceMappingURL=Version.js.map